/** What every screen shares: the workspace being looked at and the caller's view of it. */
import { get } from "./api.ts";
import type { Overview, TeamWorkspace } from "./types.ts";

const WS_KEY = "foreach.admin.workspace";

export const state = {
  workspaces: [] as TeamWorkspace[],
  ws: null as TeamWorkspace | null,
  email: "",
  overview: null as Overview | null,
  filters: { group: "", track: "" },
};

export const wsBase = () => `/v1/team/${encodeURIComponent(state.ws!.id)}`;
export const isAdmin = () => state.ws != null && !state.ws.lead;

export function pickWorkspace(id: string | null) {
  const found = state.workspaces.find((w) => w.id === id) ?? state.workspaces[0] ?? null;
  state.ws = found;
  state.overview = null;
  try {
    if (found) localStorage.setItem(WS_KEY, found.id);
  } catch {
    // Not remembering the pick is fine.
  }
}

export function rememberedWorkspace(): string | null {
  try {
    return localStorage.getItem(WS_KEY);
  } catch {
    return null;
  }
}

export async function loadWorkspaces() {
  const [w, me] = await Promise.all([
    get<{ workspaces: TeamWorkspace[] }>("/v1/team/workspaces"),
    get<{ user?: { email?: string }; email?: string }>("/v1/me").catch(() => ({}) as { user?: { email?: string }; email?: string }),
  ]);
  state.workspaces = w.workspaces;
  state.email = me.user?.email ?? me.email ?? "";
}

/** The overview, refetched when the filters change or when `fresh` is asked for. */
export async function loadOverview(fresh = false): Promise<Overview> {
  if (state.overview && !fresh) return state.overview;
  const q = new URLSearchParams();
  if (state.filters.group) q.set("group", state.filters.group);
  if (state.filters.track) q.set("track", state.filters.track);
  state.overview = await get<Overview>(`${wsBase()}/overview${q.size ? `?${q}` : ""}`);
  return state.overview;
}
